// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1tlPa","infoBtn":"quickbooks_infoBtn__xAp_h","formBox":"quickbooks_formBox__1oXGR","formFooter":"quickbooks_formFooter__2AFjD"};